let shouldViewAllButtonsBeUnderlineStyle = true;

function changeViewAllButtonsToUnderlineStyle() {
  let newSvg = createSVG();

  // Define child (anchor tag)
  let anchorTag = i.childNodes[1];

  // Get inner text from existing button
  let btnInnerText = anchorTag.innerText;

  // Create label element
  let labelSpan = document.createElement('span');
  labelSpan.classList.add('label');
  labelSpan.innerText = btnInnerText;

  console.log(labelSpan);

  // Clear existing innerText from DOM
  anchorTag.innerText = '';

  // Add span to DOM
  anchorTag.appendChild(labelSpan);
  anchorTag.appendChild(newSvg);

  // add class to button
  let classesToAdd = ['button--cta', 'focus-inset']
  anchorTag.classList.add(...classesToAdd);
}

function createSVG() {
  let svgSelector = document.querySelector('.button--cta svg');
  let pathSelector = document.querySelector('.button--cta svg path');
  console.log(svgSelector);

  // create svg
  let svgElem = document.createElementNS("http://www.w3.org/2000/svg", 'svg');
  let pathElem = document.createElementNS("http://www.w3.org/2000/svg", 'path');
  svgElem.appendChild(pathElem);

  // get properties of svg
  let svgProperties = {
    xmlns: svgSelector.getAttribute('xmlns'),
    aria: svgSelector.getAttribute('aria-hidden'),
    focusable: svgSelector.getAttribute('focusable'),
    class: svgSelector.classList,
    fill: svgSelector.getAttribute('fill'),
    viewBox: svgSelector.getAttribute('viewBox'),
  }

  let pathProperties = {
    'fill-rule': pathSelector.getAttribute('fill-rule'),
    'clip-rule': pathSelector.getAttribute('clip-rule'),
    d: pathSelector.getAttribute('d'),
    fill: pathSelector.getAttribute('fill')
  }

  // Loop through properties and create them on the new svg
  for (let [key, value] of Object.entries(svgProperties)) {
    if (key == 'xmlns') {
      svgElem.setAttributeNS("http://www.w3.org/2000/xmlns/", 'xmlns:xlink', "http://www.w3.org/1999/xlink");
    }
    svgElem.setAttribute(key, value);
  }

  for (let [key, value] of Object.entries(pathProperties)) {
    pathElem.setAttribute(key, value);
  }

  return svgElem;
}

if (shouldViewAllButtonsBeUnderlineStyle == true) {
  // Select all containers
  let btnContainer = document.querySelectorAll('.view-all.center');

  for (i of btnContainer) {
    changeViewAllButtonsToUnderlineStyle(i)
  };
}

// Judge.me Histogram Classes
// let hasRun = false;

// const observer = new MutationObserver((mutations) => {
//   if (hasRun) return;
//   const histogram = document.querySelector('.jm-histogram:not(.jdgm-temp-hidden)');

//   if (histogram) {
//     const histogramRows = document.querySelectorAll('.jm-histogram-row');

//     if (histogramRows.length > 0) {
//       hasRun = true;
//       console.log('App found with visible content');
//       observer.disconnect();
//       toggleSelectedClass(histogram, histogramRows);
//     }
//   }
// });

// observer.observe(document.body, {
//   childList: true,
//   subtree: true,
//   attributes: true,
//   attributeFilter: ['class']
// });

// function addClearFiltersButton(item, list) {
//   let clearFiltersButton = document.getElementById('rk-button__clear-filters');
//   if (!clearFiltersButton) {
//     clearFiltersButton = document.createElement('p');
//     clearFiltersButton.setAttribute('id', "rk-button__clear-filters");
//     clearFiltersButton.innerText = "✕";
//     item.appendChild(clearFiltersButton);
//   }

//   clearFiltersButton.addEventListener('click', (e) => {
//     e.preventDefault();
//     e.stopPropagation();

//     const selectedRow = Array.from(list).find(row => row.classList.contains('rk-selected'));

//     if (selectedRow) selectedRow.click();

//     console.log(`Clicked clear filters button.`);
//     for (const row of list) {
//       row.classList.remove('rk-selected');
//       console.log('Class removed from:', row);
//     }
//     removeClearFiltersButton()
//   })
// }

// function removeClearFiltersButton() {
//   let button = document.getElementById('rk-button__clear-filters');
//   if (button) {
//     button.remove();
//   }
// }

// function toggleSelectedClass(block, list) {
//   for (const item of list) {
//     item.addEventListener('click', (e) => {
//       const wasSelected = item.classList.contains('rk-selected');

//       for (const row of list) {
//         row.classList.remove('rk-selected');
//         removeClearFiltersButton();
//       }

//       if (wasSelected) {
//         return;
//       }
//       item.classList.add('rk-selected');
//       console.log('Class added to:', item);
//       addClearFiltersButton(item, list);
//     });
//   }
// }


// if (!wasSelected) {
// item.classList.add('rk-selected');
// console.log('Class added to:', item);
// removeClearFiltersButton();
//       }
// addClearFiltersButton(item, list);